const BodhiProtectThankYou = () => {
  return (
    <div
      style={{
        backgroundColor: "#191919",
        display: "flex",
        justifyContent: "center",
        minHeight: "100vh",
        width: "100%",
      }}
    >
      <div
        style={{
          maxWidth: "768px",
          width: "100%",
          height: "100%",
          backgroundColor: "#fff",
          padding: "16px",
          minHeight: "100vh",
        }}
      >
        <div
          style={{
            margin: "40px auto",
            fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
            color: "#111827",
          }}
        >
          <h1
            style={{
              fontSize: "28px",
              fontWeight: 700,
              marginBottom: "8px",
              color: "#111827",
            }}
          >
            Thank you for adding BodhiProtect
          </h1>

          <p
            style={{
              fontSize: "16px",
              lineHeight: 1.6,
              marginBottom: "16px",
              color: "#4B5563",
            }}
          >
            Your booking is now protected. If the unexpected happens and you need to
            change or cancel, you’ll have coverage according to the BodhiProtect
            terms.
          </p>

          {/* <p
            style={{
              fontSize: "15px",
              lineHeight: 1.6,
              marginBottom: "16px",
              color: "#4B5563",
            }}
          >
            We’ve emailed a confirmation with all the details of your protection
            plan. Keep it handy for your records and for quick reference before
            your ride.
          </p>

          <div
            style={{
              marginTop: "24px",
              padding: "12px 16px",
              borderRadius: "8px",
              backgroundColor: "#F3F4FF",
              border: "1px solid #E5E7EB",
              color: "#1F2937",
              fontSize: "14px",
            }}
          >
            <strong style={{ display: "block", marginBottom: "4px" }}>
              What’s next?
            </strong>
            <span>
              You can close this window and continue with your booking. Your
              BodhiProtect coverage has already been applied to this reservation.
            </span>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default BodhiProtectThankYou;
